export default __webpack_public_path__ + "static/media/bannersweb_checoleyenda_rojo_330x330.72ce26c6.jpg";